export default __webpack_public_path__ + "static/media/rest.0e5e2549.png";